import { h, render, onMounted, ref } from 'vue'
import { uid } from 'radash'

// Usage

// import ModalWindow
// import ComponentContent
// modalWindowProps = { wrapperClass: 'max-w-2xl overflow-y-auto rounded-xl bg-white p-4 shadow-lg' }
// componentContent = { heading: 'hello world' }
// createComponent(ModalWindow, modalWindowProps, ComponentContent, componentContent)
function createComponent (WrapperComponent, wrapperProps = {}, ComponentContent = {}, componentProps = {}, id = null) {
  const el = document.createElement('div')
  document.body.appendChild(el)

  el.id = id || `modal-${uid(6)}`

  const Wrapper = {
    setup () {
      const isOpen = ref(false)

      function destroy () {
        if (el) {
          render(null, el)
          el.remove()
        }
      }

      onMounted(() => {
        document.body.style.overflow = 'hidden'
        isOpen.value = true
      })

      async function close () {
        isOpen.value = false
        document.body.style.overflow = ''

        setTimeout(() => {
          destroy()
        }, 600)
      }

      return () =>
        h(WrapperComponent, { close: close, isOpen: isOpen.value, ...wrapperProps }, () =>
          h(ComponentContent, { close, ...componentProps })
        )
    }
  }

  render(h(Wrapper), el)

  return {
    destroy () {
      if (wrapperProps.destroy) {
        wrapperProps.destroy()
      }
    }
  }
}

export default createComponent
